import React from 'react';
import './Showcase.css';
import Carousel from '../components/Carousel.js';

const Showcase = () => {
  return (
    <section id="showcase">
      <Carousel />
    </section>
  );
};

export default Showcase;
